import styled from "styled-components";
import pic1 from "../images/stories/1.jpeg";
import pic2 from "../images/stories/2.jpeg";
import pic3 from "../images/stories/3.jpeg";

import Reveal from "./Shared/Reveal";
import { Container, Section, H2, Lead } from "./Shared/ui";

const STORIES = [pic1, pic2, pic3];

const OurStories = () => {
  return (
    <Tinted>
      <Container>
        <Head>
          <Reveal>
            <H2>Success stories</H2>
            <Lead>
              Hundreds of families from different communities have found their match through Vinayaka Matrimony.
            </Lead>
          </Reveal>
        </Head>

        <Fan>
          {STORIES.map((src, i) => (
            <Reveal key={src} index={i} className={`story story-${i}`}>
              <figure>
                <img src={src} alt="A couple who met through Vinayaka Matrimony on their wedding day" loading="lazy" width="196" height="220" />
              </figure>
            </Reveal>
          ))}
        </Fan>
      </Container>
    </Tinted>
  );
};

const Tinted = styled(Section)`
  background: var(--surface-tint);
  overflow: hidden;
`;

const Head = styled.div`
  text-align: center;

  p {
    margin: 0 auto;
  }
`;

const Fan = styled.div`
  display: flex;
  justify-content: center;
  align-items: flex-end;
  margin-top: clamp(40px, 6vw, 64px);
  padding-bottom: 12px;

  .story {
    flex: none;
  }

  figure {
    margin: 0;
    padding: 10px 10px 40px;
    background: var(--surface);
    border-radius: 18px;
    box-shadow: var(--shadow-lg);
    transition: transform 0.6s var(--ease-out);
  }

  img {
    width: clamp(150px, 20vw, 240px);
    height: auto;
    aspect-ratio: 196 / 220;
    object-fit: cover;
    border-radius: 10px;
  }

  .story-0 figure { transform: rotate(-7deg) translateX(28px); }
  .story-1 figure { transform: translateY(-24px); position: relative; z-index: 1; }
  .story-2 figure { transform: rotate(7deg) translateX(-28px); }

  @media (hover: hover) {
    &:hover .story-0 figure { transform: rotate(-3deg) translateX(-12px); }
    &:hover .story-1 figure { transform: translateY(-36px); }
    &:hover .story-2 figure { transform: rotate(3deg) translateX(12px); }
  }

  @media (max-width: 560px) {
    img {
      width: 38vw;
    }

    figure {
      padding: 6px 6px 24px;
    }

    .story-0 figure { transform: rotate(-7deg) translateX(30%); }
    .story-2 figure { transform: rotate(7deg) translateX(-30%); }
  }
`;

export default OurStories;
